import React from 'react';
import PropTypes from 'prop-types';
import { UserWhite } from '../../../images/';
import { Box, Text } from '@chakra-ui/react';

const UserAvatar = ({ firstName, lastName, ...rest }) => {
  return (
    <Box d="flex" alignItems="center" {...rest}>
      <UserWhite style={{ marginRight: 14 }} />
      <Text fontWeight="500" color="brand.100">{`${firstName} ${lastName}`}</Text>
    </Box>
  );
};

UserAvatar.propTypes = {
  firstName: PropTypes.string,
  lastName: PropTypes.string,
};

UserAvatar.defaultProps = {
  firstName: '',
  lastName: '',
};

export default UserAvatar;
